import { EShowArchType } from "@/gluelayer"
import { EIPRNtoNType } from "@/shared/types"
import { wasmModule } from "../wasm/wasmModule"

class SpaceManagement {
  // 控制开关，本模块调用需要先开启开关
  SwitchModuleSpaceManagement(isOpen: boolean) {
    if (!wasmModule.isFinishedOpencase) {
      return
    }
    try {
      wasmModule.moduleManager.SwitchModuleSpaceManagement(isOpen)
    } catch (e) {
      console.log("SpaceManagement:", e)
    }
  }

  // 获取当前模块的内容实例方法
  GetModuleSpaceManagement() {
    if (!wasmModule.isFinishedOpencase) {
      return undefined
    }
    try {
      return wasmModule.moduleManager.GetModuleSpaceManagement()
    } catch (e) {
      console.log("SpaceManagement:", e)
      return null
    }
  }

  SetIPRNtoN(type: EIPRNtoNType, isMidLine: boolean) {
    if (!wasmModule.isFinishedOpencase) {
      return
    }
    try {
      const spaceManagement =
        wasmModule.moduleManager.GetModuleSpaceManagement()
      if (spaceManagement) {
        spaceManagement.IPRNtoN(Number(type), isMidLine)
      }
    } catch (e) {
      console.log("Error toggling GDS module:", e)
    }
  }

  SetResolveCollision(archType: EShowArchType | null, callback: () => void) {
    if (!wasmModule.isFinishedOpencase) {
      return
    }
    try {
      const spaceManagement =
        wasmModule.moduleManager.GetModuleSpaceManagement()
      if (spaceManagement) {
        ;(window as any).resolveCollisionCallback = callback
        spaceManagement.ResolveCollision(archType, "resolveCollisionCallback")
      }
    } catch (e) {
      console.log("Error toggling GDS module:", e)
    }
  }

  /**
   *
   */
  IsFinalStage(archType: EShowArchType) {
    if (!wasmModule.isFinishedOpencase) {
      return false
    }
    try {
      const spaceManagement =
        wasmModule.moduleManager.GetModuleSpaceManagement()
      if (spaceManagement) {
        return spaceManagement.IsFinalStage(archType)
      }
      return false
    } catch (e) {
      console.log("Error toggling GDS module:", e)
      return false
    }
  }

  /**
   * 获取 牙齿移动了，ipr 变化值
   */
  SetUpdateTotalIPRCallback(
    callback: (UpData: string, LowData: string) => any,
  ) {
    if (!wasmModule.isFinishedOpencase) {
      return false
    }
    try {
      const spaceManagement =
        wasmModule.moduleManager.GetModuleSpaceManagement()
      if (spaceManagement) {
        ;(window as any).setUpdateTotalIPRCallback = callback
        spaceManagement.SetUpdateTotalIPRCallback("setUpdateTotalIPRCallback")
      }
    } catch (e) {
      console.log("Error SetUpdateTotalIPRCallback:", e)
    }
  }

  /**
   * 获取IPR 初始化值
   */
  GetTotalIPRValue() {
    if (!wasmModule.isFinishedOpencase) {
      return []
    }
    try {
      const spaceManagement =
        wasmModule.moduleManager.GetModuleSpaceManagement()
      if (spaceManagement) {
        return spaceManagement.GetTotalIPRValue()
      }
      return []
    } catch (e) {
      console.log("Error GetTotalIPRValue:", e)
      return []
    }
  }

  IsWillShift(archType: EShowArchType) {
    if (!wasmModule.isFinishedOpencase) {
      return false
    }
    try {
      const spaceManagement =
        wasmModule.moduleManager.GetModuleSpaceManagement()
      if (spaceManagement) {
        return spaceManagement.IsWillShift(archType)
      }
      return false
    } catch (e) {
      console.log("Error IsWillShift:", e)
      return false
    }
  }
}

export const spaceManagement = new SpaceManagement()
